var map = {
	"./appointments.svg": [
		1535,
		341
	],
	"./companies.svg": [
		1536,
		342
	],
	"./dining.svg": [
		1537,
		343
	],
	"./events.svg": [
		1538,
		344
	],
	"./members.svg": [
		1534,
		345
	],
	"./perks.svg": [
		1539,
		346
	],
	"./placeholder.svg": [
		1540,
		347
	],
	"./rooms.svg": [
		1541,
		348
	],
	"./store.svg": [
		1542,
		349
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1515;
module.exports = webpackAsyncContext;